import React from 'react';

const Image = (props = {}) => {
    const {
        alt, src, src2x, style,
    } = props;

    const srcSet = src2x ? `${src2x} 2x` : undefined;

    return (
        <img alt={alt} src={src} srcSet={srcSet} style={style} />
    );
};

export default Image;
